module.exports = __webpack_public_path__ + "img/lingyuankaidian.8392719b.png";